import webClient from "../config/api.config";
import {
  DoctorLicencePlanType,
  DoctorLicencePricingEnabledUpdateRequest,
  DoctorLicencePricingUpdateRequest,
} from "../types/doctorLicencePricing.definition";

export function getAllDoctorLicencePricing() {
  return webClient.request({ method: "get", url: "/doctor-licence-pricing" });
}

export function updateDoctorLicencePricing(
  id: number,
  data: DoctorLicencePricingUpdateRequest
) {
  return webClient.request({
    method: "put",
    url: `/doctor-licence-pricing/${id}`,
    data,
  });
}

export function updateDoctorLicencePricingEnabled(
  planType: DoctorLicencePlanType,
  data: DoctorLicencePricingEnabledUpdateRequest
) {
  return webClient.request({
    method: "patch",
    url: `/doctor-licence-pricing/${planType}/enabled`,
    data,
  });
}
